import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\45\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './SocialSharingControl.css';
import React from 'react';
import { ReactComponent as IconClose } from '../../resources/icons/close-white.svg';
import { get, getGlobalDictionaryTerm } from '../../utils';
import { ReactComponent as ShareIcon } from '../../resources/icons/ShareIcon.svg';
import LazyPicture from '../atoms/LazyPicture';
import { SitecoreContextReactContext } from "../../utils/SitecoreContextReactContext";
import { handleAnalitics } from "../../utils/tealium";
var SocialSharingControl = function SocialSharingControl(_ref) {
  var videoSocialSharing = _ref.videoSocialSharing,
    shareLink = _ref.shareLink,
    analytics = _ref.analytics,
    name = _ref.name,
    params = _ref.params;
  var _React$useContext = React.useContext(SitecoreContextReactContext),
    origin = _React$useContext.origin;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var newWindowLabel = getGlobalDictionaryTerm(sitecoreContext, 'newWindowLabel') || "Opens in a new window";
  var socialLinks = get(videoSocialSharing, 'socialLinks.values');
  var title = get(videoSocialSharing, 'title.jss.value');
  var likeButtonsTitle = get(videoSocialSharing, 'likeButtonsTitle.jss.value');
  var BASE_URL = String(process.env.REACT_APP_MEDIA_HOST || '');
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isOpen = _React$useState2[0],
    handleOpen = _React$useState2[1];
  var togglePannel = function togglePannel() {
    handleOpen(!isOpen);
    if (!isOpen) {
      handleAnalitics({
        params: params,
        title: name,
        objectParamName: "Share Param",
        objectParams: analytics
      });
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(socialSharingControl, " ").concat(rtl ? socialSharingControlRtl : socialSharingControlLtl)
  }, /*#__PURE__*/React.createElement("div", {
    className: "socialSharing"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn--reset buttonRow__btn--btn-lvl1",
    onClick: togglePannel,
    onKeyPress: function onKeyPress(e) {
      if (e.which === 13) {
        e.preventDefault();
        togglePannel();
      }
    }
  }, /*#__PURE__*/React.createElement(ShareIcon, null)), isOpen && /*#__PURE__*/React.createElement("div", {
    className: "socialSharing__row"
  }, /*#__PURE__*/React.createElement("span", null, title), socialLinks.map(function (item) {
    var icon = get(item, 'icon.jss.value.src');
    var iconAlt = get(item, 'icon.jss.value.alt');
    var link = get(item, 'link.jss.value', '');
    var svgIcon = get(item, 'svgIcon.jss.value');
    var nameSocial = get(item, 'name');
    if (link) link = link.replace('${message}', likeButtonsTitle).replace('${link}', origin + shareLink);
    return /*#__PURE__*/React.createElement("a", {
      href: link,
      target: "_blank",
      rel: "noopener noreferrer",
      "aria-label": "".concat(nameSocial, " | ").concat(newWindowLabel),
      onKeyPress: function onKeyPress(event) {
        if (event.key === "Enter" || event.key === "NumpadEnter") {
          event.preventDefault();
          event.target.click();
        }
      },
      onClick: function onClick() {
        handleAnalitics({
          params: params,
          title: [name, nameSocial],
          objectParamName: "Social Platform Param",
          objectParams: analytics
        });
      }
    }, svgIcon ? /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: svgIcon
      },
      className: "social-sharing__a-icon"
    }) : /*#__PURE__*/React.createElement(LazyPicture, {
      useEmptyPlaceholder: true,
      className: nameSocial
    }, /*#__PURE__*/React.createElement("source", {
      media: "(min-width: 768px)",
      srcSet: BASE_URL + icon
    }), /*#__PURE__*/React.createElement("img", {
      className: "social-sharing__icon",
      src: BASE_URL + icon,
      alt: iconAlt,
      title: iconAlt
    })));
  }), /*#__PURE__*/React.createElement("button", {
    className: "socialSharing__row--closeIcon btn--reset",
    onClick: togglePannel,
    onKeyPress: function onKeyPress(e) {
      if (e.which === 13) {
        e.preventDefault();
        togglePannel();
      }
    }
  }, /*#__PURE__*/React.createElement(IconClose, null)))));
};
export var socialSharingControl = "sm5tl2r";
export var socialSharingControlLtl = "s1rrwt2c";
export var socialSharingControlRtl = "s1obrgfc";
// @ts-ignore
export default SocialSharingControl;